import React, { useContext,useState } from "react";
import {
  BoldLinkB,
  BoxContainerB,
  FormContainerB,
  InputB,
  MutedLinkB,
  SubmitButtonB,
} from "./Components";
import { Marginer } from "./marginer";
import { AccountContext } from "./accountContext";
import { useSelector, useDispatch } from 'react-redux'
import { customer_register } from '../../store/reducers/authReducer'
import HashLoader from 'react-spinners/HashLoader'
import { RiEyeCloseFill, RiEyeFill } from "react-icons/ri";

export function SignupForm() {
  const { switchToSignin } = useContext(AccountContext);
  const { loader} = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const [state, setState] = useState({
    email: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    })
  }
  const register = (e) => {
    e.preventDefault()
    dispatch(customer_register(state))
  }

  return (
    <>
      {
        loader && <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
          <HashLoader color='#BD5344' />
        </div>
      }
      <BoxContainerB>
        <FormContainerB onSubmit={register}>
          <InputB onChange={inputHandle} value={state.name} type='text' id='name' name='name' placeholder='Full Name' />
          <InputB onChange={inputHandle} value={state.email} type="email" id='email' name='email' placeholder='Email' />
          <div className="flex ">
          <InputB onChange={inputHandle} value={state.password} type={showPassword ? 'text' : 'password'} id='password' name='password' placeholder='Password' />
          <button
            type='button'
            className='block bg-[#eee] py-[13px] px-3 cursor-pointer'
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
          </button>
          </div>
        </FormContainerB>
        <Marginer direction="vertical" margin={10} />
        <SubmitButtonB onClick={register}>Signup</SubmitButtonB>
        <Marginer direction="vertical" margin="1em" />
        <MutedLinkB href="#">
          Already have an account?
          <BoldLinkB href="#" onClick={switchToSignin}>
            Signin
          </BoldLinkB>
        </MutedLinkB>
      </BoxContainerB>
    </>
  );
}
